const s = (t) => {
  if (!t)
    return "";
  if (t.length === 1)
    return `gap-${t}`;
  const n = t.split(" ")[0], r = t.split(" ")[1];
  return `gap-y-${n} gap-x-${r}`;
};
export {
  s as n
};
